import { useAuthListener } from 'app/hooks/useAuthListener';
import React, { createContext, useContext } from 'react';

const AuthContext = createContext<{
  isAuthenticated: boolean;
} | null>(null);

interface Props {
  children: React.ReactNode;
}

export function AuthProvider({ children }: Props) {
  const isAuthenticated = useAuthListener();

  const value = {
    isAuthenticated,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export default useAuth;
